import PropTypes from 'prop-types';

export const productProps = {
  discountPrice: PropTypes.string,
  bannerType: PropTypes.string,
  giftPurchaseUrl: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isFreeListing: PropTypes.bool,
  listingPrice: PropTypes.string,
  purchaseUrl: PropTypes.string,
  savingsPercent: PropTypes.string,
  showListingPrice: PropTypes.bool,
  timeLeft: PropTypes.string,
};

export const product = PropTypes.shape(productProps);
